import {request} from '@/api';
import {Token} from '@/api/token.ts';

interface TokenResponse {
	token: string,
}

export class Auth {
	public static async refresh(): Promise<Token|null> {
		const response: TokenResponse = await request('/auth/refresh');
		return Token.tryCreate(response.token);
	}
}
